<div class="accordion-item">
    <div class="flex flex-col gap-4">
        <button
            class="w-full px-6 py-4 flex items-center justify-between relative bg-transparent cursor-pointer"
            [class.border-bottom-partial]="item.isOpen"
            [class.border-b]="!item.isOpen"
            [class.border-gray-10]="true"
            (click)="toggleAccordion()"
        >
            <span class="typography-body-m-regular text-gray-900">
                {{ item.question }}
            </span>
            <svg [class.rotate-180]="item.isOpen" class="w-5 h-5 transition-transform duration-200" viewBox="0 0 20 20" fill="#365BCA">
                <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
            </svg>
        </button>

        <div *ngIf="item.isOpen" class="px-6 pb-6">
            <span class="text-gray-600">{{ item.answer }}</span>
        </div>
    </div>
</div>
